/**
 * Used by the actExportButton directive to expose a function to the directive view template that can be invoked from an ng-click expression binding
 */
export class ExportButtonController {
  public exportHandler: Function;
}